import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Quote, ChevronLeft, ChevronRight } from "lucide-react";
import { TESTIMONIALS } from "@/data/testimonials";

export default function Testimonials() {
  const [i, setI] = useState(0);
  const t = TESTIMONIALS[i];
  const prev = () => setI((p) => (p - 1 + TESTIMONIALS.length) % TESTIMONIALS.length);
  const next = () => setI((p) => (p + 1) % TESTIMONIALS.length);

  return (
    <section className="relative bg-white py-24 sm:py-32" data-testid="testimonials-section">
      <div className="container-x">
        <div className="grid lg:grid-cols-12 gap-12 items-start">
          <div className="lg:col-span-4">
            <div className="overline text-emerald-brand">Client voices</div>
            <h2 className="font-display font-extrabold text-4xl sm:text-5xl text-navy mt-4 leading-[1.05]">
              What our clients say about working with us.
            </h2>
            <div className="mt-10 flex items-center gap-3">
              <button
                onClick={prev}
                data-testid="testimonial-prev"
                className="w-12 h-12 grid place-items-center border border-slate-300 hover:border-navy hover:bg-navy hover:text-white transition-colors"
                aria-label="Previous"
              >
                <ChevronLeft size={18} />
              </button>
              <button
                onClick={next}
                data-testid="testimonial-next"
                className="w-12 h-12 grid place-items-center border border-slate-300 hover:border-navy hover:bg-navy hover:text-white transition-colors"
                aria-label="Next"
              >
                <ChevronRight size={18} />
              </button>
              <span className="ml-2 text-xs text-slate-brand font-mono-alt">
                {String(i + 1).padStart(2, "0")} / {String(TESTIMONIALS.length).padStart(2, "0")}
              </span>
            </div>
          </div>

          <div className="lg:col-span-8 relative min-h-[280px]">
            <AnimatePresence mode="wait">
              <motion.div
                key={t.name}
                initial={{ opacity: 0, y: 18 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, y: -18 }}
                transition={{ duration: 0.45 }}
                className="relative p-8 sm:p-12 bg-mist border-l-2 border-gold"
                data-testid="testimonial-card"
              >
                <Quote className="text-gold/40" size={48} />
                <p className="mt-6 font-display text-2xl sm:text-3xl text-navy leading-snug">
                  &ldquo;{t.quote}&rdquo;
                </p>
                <div className="mt-8 flex items-center gap-4">
                  <img src={t.photo} alt={t.name} className="w-14 h-14 object-cover" loading="lazy" />
                  <div>
                    <div className="font-display font-semibold text-navy">{t.name}</div>
                    <div className="text-xs text-slate-brand mt-0.5">
                      {t.role} · {t.org}
                    </div>
                  </div>
                </div>
              </motion.div>
            </AnimatePresence>
          </div>
        </div>
      </div>
    </section>
  );
}
